import { render, staticRenderFns } from "./SlsN_Items_List.vue?vue&type=template&id=1932077a"
import script from "./SlsN_Items_List.vue?vue&type=script&lang=js"
export * from "./SlsN_Items_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports